"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformacionPersonal = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var select_modif_js_1 = require("../utils/select_modif.js");
var FaIcons = require("react-icons/fa");
var AiIcons = require("react-icons/ai");
var Clases = require("../../clases_comunes");
var OpcionesList = require("../../opciones.js");
var TriagunloAzul = require("../../assets/img/AzulPng.png");
var InformacionPersonal = /** @class */ (function (_super) {
    __extends(InformacionPersonal, _super);
    function InformacionPersonal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            alertaDomicilio: false, alertaTelefono: false, mensajeTelefono: [], tipoFonoSelect: "", mensajeDomicilio: "",
            datosalumni: new Clases.DatosAlumni(), infopersonal: new Clases.InfoPersonal(),
            telecelalum: new Clases.TblTelefonoInfo(), telecasaalum: new Clases.TblTelefonoInfo(),
            //datosalumni: null, infopersonal: null, telecelalum: null, telecasaalum: null,
            paisSelectedOptionA: { "value": 0, "label": "", "link": 0 },
            provSelectedOptionA: { "value": 0, "label": "", "link": 0, "linkciud": 0 },
            ciudSelectedOptionA: { "value": 0, "label": "", "link": 0 },
        };
        // METODOS
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.validarAvanceSiguiente = _this.validarAvanceSiguiente.bind(_this);
        return _this;
    }
    InformacionPersonal.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            datosalumni: this.props.datosalumni, infopersonal: this.props.infopersonal,
            telecelalum: this.props.telecelalum, telecasaalum: this.props.telecasaalum,
            tipoFonoSelect: "C"
        }, function () {
            _this.showNewQuestions("tipoTelefonoAlumni", "C");
            _this.cargarNacionalidad();
            _this.cargarLugarDomicilio();
        });
    };
    InformacionPersonal.prototype.cargarLugarDomicilio = function () {
        var domicilio = this.state.infopersonal;
        var paisOptionDom = this.state.paisSelectedOptionA;
        var provOptionDom = this.state.provSelectedOptionA;
        var ciudOptionDom = this.state.ciudSelectedOptionA;
        // DOMICILIO
        if (domicilio.codpaisdom > 0 && domicilio.codpaisdom !== null) {
            paisOptionDom = this.props.paisesSelectList.filter(function (p) { return p.link === domicilio.codpaisdom; })[0];
        }
        if (domicilio.codprovdom > 0 && domicilio.codprovdom !== null) {
            provOptionDom = this.props.provinciasSelectList.filter(function (p) { return p.value === domicilio.codprovdom; })[0];
        }
        if (domicilio.codciuddom > 0 && domicilio.codciuddom !== null) {
            ciudOptionDom = this.props.ciudadesSelectList.filter(function (c) { return c.value === domicilio.codciuddom; })[0];
        }
        this.setState({
            paisSelectedOptionA: paisOptionDom, provSelectedOptionA: provOptionDom, ciudSelectedOptionA: ciudOptionDom
        });
    };
    InformacionPersonal.prototype.cargarNacionalidad = function () {
        var _this = this;
        var nacionalidad2 = this.props.paisesList.filter(function (p) { return p.siIdPais === _this.state.datosalumni.idnacionalidad; });
        var nacionalidad = this.props.paisesList.filter(function (p) { return p.siIdPais === _this.state.datosalumni.idnacionalidad; }).map(function (p) { return p.strNacionalidad; }).toString();
        document.getElementById("nacionalidad").value = nacionalidad;
    };
    InformacionPersonal.prototype.handleChange = function (event) {
        if (event.target.name.startsWith("infper")) {
            var tnameip = event.target.name.split("-");
            var dtopersonal = this.state.infopersonal;
            dtopersonal[tnameip[1]] = event.target.value;
            this.setState({ infopersonal: dtopersonal });
        }
        else if (event.target.name.startsWith("fono")) {
            var tnamefi = event.target.name.split("-");
            if (tnamefi[0] === "fonocel") {
                var celalumni = this.state.telecelalum;
                celalumni[tnamefi[2]] = event.target.value;
                this.setState({ telecelalum: celalumni });
            }
            else if (tnamefi[0] === "fonocasa") {
                var domalumni = this.state.telecasaalum;
                domalumni[tnamefi[2]] = event.target.value;
                this.setState({ telecasaalum: domalumni });
            }
        }
    };
    InformacionPersonal.prototype.handleSelectChange = function (selectedOption, selName) {
        var _this = this;
        if (selectedOption != null) {
            if (selName.name.startsWith("infper")) {
                var paisSelOpt = this.state.paisSelectedOptionA;
                var provSelOpt = this.state.provSelectedOptionA;
                var ciudSelOpt = this.state.ciudSelectedOptionA;
                var tnameips = selName.name.split("-");
                var dtopersonal = this.state.infopersonal;
                dtopersonal[tnameips[1]] = selectedOption.value;
                if (selName.name.includes("pais")) {
                    paisSelOpt = selectedOption;
                    dtopersonal["codprovdom"] = 0;
                    dtopersonal["codciuddom"] = 0;
                    dtopersonal["parroqdom"] = 0;
                }
                else if (selName.name.includes("prov")) {
                    provSelOpt = selectedOption;
                    dtopersonal["codciuddom"] = 0;
                    dtopersonal["parroqdom"] = 0;
                }
                else if (selName.name.includes("ciud")) {
                    ciudSelOpt = selectedOption;
                    dtopersonal["parroqdom"] = 0;
                }
                this.setState({ infopersonal: dtopersonal, paisSelectedOptionA: paisSelOpt, provSelectedOptionA: provSelOpt, ciudSelectedOptionA: ciudSelOpt }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
            else if (selName.name.startsWith("fono")) {
                var tnamef = selName.name.split("-");
                if (tnamef[0] === "fonocel") {
                    var celalumni = this.state.telecelalum;
                    if (tnamef[2] === "codigopais") {
                        celalumni["idpais"] = selectedOption.value;
                        celalumni["codigopais"] = selectedOption.link;
                    }
                    else {
                        celalumni[tnamef[2]] = selectedOption.value;
                    }
                    this.setState({ telecelalum: celalumni }, function () {
                        _this.showNewQuestions(selName.name, selectedOption.link);
                    });
                }
                else if (tnamef[0] === "fonocasa") {
                    var domalumni = this.state.telecasaalum;
                    if (tnamef[2] === "codigopais") {
                        domalumni["idpais"] = selectedOption.value;
                        domalumni["codigopais"] = selectedOption.link;
                    }
                    else {
                        domalumni[tnamef[2]] = selectedOption.value;
                    }
                    this.setState({ telecasaalum: domalumni }, function () {
                        _this.showNewQuestions(selName.name, selectedOption.link);
                    });
                }
            }
            else if (selName.name === "tipoTelefonoAlumni") {
                this.setState({ tipoFonoSelect: selectedOption.value }, function () { _this.showNewQuestions(selName.name, selectedOption.value); });
            }
        }
    };
    InformacionPersonal.prototype.showNewQuestions = function (name, answer) {
        if (name === "tipoTelefonoAlumni") {
            document.getElementById("divheaderfonos").style.removeProperty("display");
            if (answer === "C") {
                var celular = this.state.telecelalum;
                // MOSTRAR CELULAR
                document.getElementById("divpaisfonocelu").style.removeProperty("display");
                document.getElementById("divareafonocelu").style.removeProperty("display");
                document.getElementById("divnumerofonocelu").style.removeProperty("display");
                // OCULTAR DOMICILIO
                document.getElementById("divpaisfonocasa").style.display = "none";
                document.getElementById("divareafonocasa").style.display = "none";
                document.getElementById("divnumerofonocasa").style.display = "none";
                if (celular.codigopais.trim() === "593") {
                    document.getElementById("areafonoincelalinp").disabled = true;
                }
                else {
                    document.getElementById("areafonoincelalinp").disabled = false;
                }
            }
            else if (answer === "D") {
                var domicilio = this.state.telecasaalum;
                // MOSTRAR DOMICILIO
                document.getElementById("divpaisfonocasa").style.removeProperty("display");
                document.getElementById("divareafonocasa").style.removeProperty("display");
                document.getElementById("divnumerofonocasa").style.removeProperty("display");
                // OCULTAR CELULAR
                document.getElementById("divpaisfonocelu").style.display = "none";
                document.getElementById("divareafonocelu").style.display = "none";
                document.getElementById("divnumerofonocelu").style.display = "none";
                if (domicilio.codigopais.trim() === "593") {
                    document.getElementById("areafonoselcasal").style.removeProperty("display");
                    document.getElementById("areafonoincasal").style.display = "none";
                }
                else if (domicilio.codigopais.trim() !== "593") {
                    document.getElementById("areafonoincasal").style.removeProperty("display");
                    document.getElementById("areafonoselcasal").style.display = "none";
                }
            }
        }
        else if (name.startsWith("fonocel-alum")) { // fonocel-alum-codigopais
            var telefonocel = this.state.telecelalum;
            var tnamete = name.split("-");
            if (tnamete[2] === "codigopais") {
                if (answer.trim() === "593") {
                    telefonocel.codigoarea = "09";
                    document.getElementById("areafonoincelalinp").disabled = true;
                }
                else {
                    document.getElementById("areafonoincelalinp").disabled = false;
                }
            }
            this.setState({ telecelalum: telefonocel });
        }
        else if (name.startsWith("fonocasa-alum")) { // fonocasa-alum-codigopais
            var fonoMoment = name.split("-");
            if (fonoMoment[2] === "codigopais") {
                if (answer.trim() === "593") {
                    document.getElementById("areafonoselcasal").style.removeProperty("display");
                    document.getElementById("areafonoincasal").style.display = "none";
                }
                else if (answer.trim() !== "593") {
                    document.getElementById("areafonoincasal").style.removeProperty("display");
                    document.getElementById("areafonoselcasal").style.display = "none";
                }
            }
        }
    };
    InformacionPersonal.prototype.closeAlert = function (name) {
        if (name === "telefonos") {
            this.setState({ alertaTelefono: false, mensajeTelefono: [] });
        }
        else if (name === "domicilio") {
            this.setState({ alertaDomicilio: false, mensajeDomicilio: "" });
        }
    };
    InformacionPersonal.prototype.validarTelefonos = function (fonocasa, fonocel) {
        var mensajes = Array();
        var tipoTeleActual = this.state.tipoFonoSelect;
        if (tipoTeleActual === "C") { // CELULAR
            if (fonocel["codigopais"].trim() === "" || fonocel["idpais"] === undefined || fonocel["idpais"] === 0) {
                mensajes.push("Ocurrió un error: Elija el código del país.");
            }
            if (fonocel["codigopais"] === "593" && fonocel["codigoarea"].trim().length === 0) {
                mensajes.push("Ocurrió un error: Elija el código de área.");
            }
            if (fonocel["codigoarea"].trim().length > 3) {
                mensajes.push("Ocurrió un error: El código área debe contener máximo 3 dígitos.");
            }
            if (fonocel["numerotelefono"].trim().length > 11 || fonocel["numerotelefono"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El número de celular debe contener máximo 11 dígitos.");
            }
            if (fonocel["codigopais"] === "593" && fonocel["numerotelefono"].trim().length !== 8) {
                mensajes.push("Ocurrió un error: El número de celular debe contener 8 dígitos.");
            }
        }
        else if (tipoTeleActual === "D") { // DOMICILIO
            if (fonocasa["codigopais"].trim() === "" || fonocasa["idpais"] === undefined || fonocasa["idpais"] === 0) {
                mensajes.push("Ocurrió un error: Elija el código del país.");
            }
            if (fonocasa["codigopais"] === "593" && fonocasa["codigoarea"].trim().length === 0) {
                mensajes.push("Ocurrió un error: Elija el código de área.");
            }
            if (fonocasa["codigoarea"].trim().length > 3) {
                mensajes.push("Ocurrió un error: El código área debe contener máximo 2 dígitos.");
            }
            if (fonocasa["numerotelefono"].trim().length > 11 || fonocasa["numerotelefono"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El número de domicilio debe contener máximo 11 dígitos.");
            }
            if (fonocasa["codigopais"] === "593" && fonocasa["numerotelefono"].trim().length !== 7) {
                mensajes.push("Ocurrió un error: El número de domicilio debe contener 7 dígitos.");
            }
        }
        if (mensajes.length > 0) {
            this.setState({ mensajeTelefono: mensajes });
            return 1;
        }
        else {
            return 0;
        }
    };
    InformacionPersonal.prototype.validarAvanceSiguiente = function (event) {
        event.preventDefault();
        var validoavanzar = true;
        var codPaisDomicilio = this.state.infopersonal.codpaisdom;
        var tele1cValidar = this.state.telecasaalum;
        var tele1mValidar = this.state.telecelalum;
        var resultTelef = this.validarTelefonos(tele1cValidar, tele1mValidar);
        if (resultTelef === 1) {
            validoavanzar = false;
        }
        if (resultTelef === 1) {
            this.setState({ alertaTelefono: true });
            document.getElementById("alertaTelefonos").scrollIntoView({
                behavior: "smooth", block: "center", inline: "center"
            });
        }
        if (codPaisDomicilio === 0) {
            validoavanzar = false;
            this.setState({ alertaDomicilio: true, mensajeDomicilio: "Ocurrió un error: Falta seleccionar país de domicilio" });
            document.getElementById("alertaDireccionDomicilio").scrollIntoView({
                behavior: "smooth", block: "center", inline: "center"
            });
        }
        if (validoavanzar) {
            this.setState({ alertaTelefono: false, alertaDomicilio: false });
            this.props.validarCambiosSeccion(event, this.state.infopersonal, this.state.tipoFonoSelect, this.state.telecasaalum, this.state.telecelalum);
        }
    };
    InformacionPersonal.prototype.render = function () {
        var _this = this;
        var provListA = this.props.provinciasSelectList.filter(function (p) { return p.link === _this.state.paisSelectedOptionA.link; });
        var ciudListA = this.props.ciudadesSelectList.filter(function (c) { return c.link === _this.state.provSelectedOptionA.linkciud; });
        var parrListA = this.props.parroquiasSelectList.filter(function (p) { return p.link === _this.state.ciudSelectedOptionA.value; });
        return (React.createElement("form", { id: "alumniform-personal", name: "alumniform-personal", onSubmit: this.validarAvanceSiguiente },
            React.createElement("div", { className: "blue-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                React.createElement("div", { id: "informacion-personal" },
                    React.createElement("div", { className: "form-group row section-title" },
                        React.createElement("div", { style: { backgroundColor: "white" } },
                            React.createElement("img", { src: TriagunloAzul, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                            React.createElement("h5", { className: "down blue-text small-h5title" }, "INFORMACI\u00D3N PERSONAL"))),
                    React.createElement("br", null),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("h5", { className: "col-sm-12 blue-text" }, "Datos Personales")),
                    React.createElement("div", { className: "form-group row no-margin-bottom" },
                        React.createElement("div", { className: "col-lg-4 col-sm-8 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "nombrealumni" }, "Nombres y Apellidos"),
                            React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.nombrecompleto, name: "nombrealumni", id: "nombrealumni", disabled: true })),
                        React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "identalumni" }, "Identificaci\u00F3n"),
                            React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.numeroidentificacion, name: "identalumni", id: "identalumni", disabled: true })),
                        React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "nacionalidad" }, "Nacionalidad"),
                            React.createElement("input", { className: "form-control form-control-sm", type: "text", name: "nacionalidad", id: "nacionalidad", disabled: true })),
                        React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "fechanacim" }, "Fecha de nacimiento"),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", name: "fechanacim", id: "fechanacim", disabled: true, value: this.state.datosalumni.fechanacimiento !== "" ? new Date(this.state.datosalumni.fechanacimiento).toLocaleDateString() : "" }),
                                React.createElement("span", { className: "input-group-text", id: "fechanacicon" },
                                    React.createElement(FaIcons.FaCalendarAlt, null)))),
                        React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "estcivil" }, "Estado Civil"),
                            React.createElement(select_modif_js_1.default, { options: OpcionesList.EstadoCivil, value: this.state.datosalumni.estadocivil, name: "estcivil", id: "estcivil", tipoicono: "estadocivil", disabled: true }))),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-lg-4 col-sm-12 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "carrera" }, "Graduado de:"),
                            this.props.graduadode.map(function (carrera, index) {
                                return (React.createElement("input", { className: "form-control form-control-sm", type: "text", value: carrera, key: index, style: { marginBottom: "10px" }, disabled: true }));
                            })),
                        React.createElement("div", { className: "col-lg-8 col-sm-12" },
                            React.createElement("div", { className: "form-group row" },
                                React.createElement("div", { className: "col-lg-3 col-sm-4 label-space" },
                                    React.createElement("label", { className: "control-label", htmlFor: "emailalumni" }, "E-mail ESPOL"),
                                    React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.email, name: "emailalumni", id: "emailalumni", disabled: true }))))),
                    React.createElement("br", null),
                    React.createElement("div", { id: "alertaDireccionDomicilio" },
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertaDomicilio, color: "danger", toggle: function () { return _this.closeAlert("domicilio"); } }, this.state.mensajeDomicilio)),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("h5", { className: "col-sm-12 blue-text" }, "Direcci\u00F3n de domicilio")),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "paisalumni" },
                                "Pa\u00EDs ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(select_modif_js_1.default, { options: this.props.paisesSelectList, value: this.state.infopersonal.codpaisdom, name: "infper-codpaisdom", id: "paisalumni", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "provalumni" }, "Provincia"),
                            React.createElement(select_modif_js_1.default, { options: provListA, value: this.state.infopersonal.codprovdom, name: "infper-codprovdom", id: "provalumni", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "provincia" })),
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "ciudalumni" }, "Ciudad"),
                            React.createElement(select_modif_js_1.default, { options: ciudListA, value: this.state.infopersonal.codciuddom, name: "infper-codciuddom", id: "ciudalumni", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "provincia" })),
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "parroqdom" }, "Parroquia"),
                            React.createElement(select_modif_js_1.default, { options: parrListA, value: this.state.infopersonal.parroqdom, name: "infper-parroqdom", id: "parroqdom", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "provincia" }))),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "calleprincipal" },
                                "Calle Principal ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infopersonal.direccion, name: "infper-direccion", id: "calleprincipal", maxLength: 199, onChange: this.handleChange, required: true }),
                                React.createElement("span", { className: "input-group-text span-background", id: "calprinicon" },
                                    React.createElement(FaIcons.FaRoute, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-3 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "callesecundaria" },
                                "Calle Secundaria ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infopersonal.direccionalterna, name: "infper-direccionalterna", id: "callesecundaria", maxLength: 199, onChange: this.handleChange, required: true }),
                                React.createElement("span", { className: "input-group-text span-background", id: "calsecicon" },
                                    React.createElement(FaIcons.FaRoute, { style: { color: "white" } }))))),
                    React.createElement("br", null),
                    React.createElement("div", { id: "alertaTelefonos" },
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertaTelefono, color: "danger", toggle: function () { return _this.closeAlert("telefonos"); } }, this.state.mensajeTelefono)),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("h5", { className: "col-sm-12 blue-text" }, "Contacto")),
                    React.createElement("div", { className: "form-group row", id: "divheaderfonos", style: { marginBottom: "0px", display: "none" } },
                        React.createElement("div", { className: "col-lg-2 col-sm-3" }),
                        React.createElement("div", { className: "col-lg-6 col-sm-9", style: { paddingLeft: "5px" } },
                            React.createElement("h6", { className: "blue-text" },
                                "Tel\u00E9fono - ",
                                this.state.tipoFonoSelect === "C" ? "Celular" : "Domicilio"))),
                    React.createElement("div", { className: "form-group row no-margin-bottom" },
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space" },
                            React.createElement("label", { className: "control-label" },
                                "Tipo Tel\u00E9fono ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(select_modif_js_1.default, { options: OpcionesList.TipoTelefonoList, value: this.state.tipoFonoSelect, name: "tipoTelefonoAlumni", id: "tipofonoalum", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "telefono" })),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divpaisfonocelu", style: { display: "none" } },
                            React.createElement("label", { className: "control-label" },
                                "C\u00F3digo Pa\u00EDs\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(select_modif_js_1.default, { options: this.props.paisesFonoList, value: this.state.telecelalum.idpais, name: "fonocel-alum-codigopais", id: "paisfonocelal", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divareafonocelu", style: { display: "none" } },
                            React.createElement("label", { className: "control-label" },
                                "C\u00F3digo \u00E1rea/estado\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3", id: "areafonoincelal" },
                                React.createElement("input", { className: "form-control form-control-sm", id: "areafonoincelalinp", name: "fonocel-alum-codigoarea", value: this.state.telecelalum.codigoarea, type: "number", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput }),
                                React.createElement("span", { className: "input-group-text span-background", id: "codare2aicon" },
                                    React.createElement(AiIcons.AiOutlineAim, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divnumerofonocelu", style: { display: "none" } },
                            React.createElement("label", { className: "control-label", htmlFor: "fononumbercelal" },
                                "N\u00FAmero\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.telecelalum.numerotelefono, name: "fonocel-alum-numerotelefono", id: "fononumbercelal", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput }),
                                React.createElement("span", { className: "input-group-text span-background", id: "number2icon" },
                                    React.createElement(AiIcons.AiOutlineNumber, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divpaisfonocasa", style: { display: "none" } },
                            React.createElement("label", { className: "control-label" },
                                "C\u00F3digo Pa\u00EDs\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(select_modif_js_1.default, { options: this.props.paisesFonoList, value: this.state.telecasaalum.idpais, name: "fonocasa-alum-codigopais", id: "paisfonocasal", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divareafonocasa", style: { display: "none" } },
                            React.createElement("label", { className: "control-label" },
                                "C\u00F3digo \u00E1rea/estado\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { id: "areafonoselcasal", style: { display: "none" } },
                                React.createElement(select_modif_js_1.default, { options: OpcionesList.AreaFonoList, value: this.state.telecasaalum.codigoarea, name: "fonocasa-alum-codigoarea", id: "areafonoselcasal1", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "codarea" })),
                            React.createElement("div", { className: "input-group input-group-sm mb-3", id: "areafonoincasal" },
                                React.createElement("input", { className: "form-control form-control-sm", name: "fonocasa-alum-codigoarea", type: "number", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput }),
                                React.createElement("span", { className: "input-group-text span-background", id: "codare1aicon" },
                                    React.createElement(AiIcons.AiOutlineAim, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-2 col-sm-3 label-space", id: "divnumerofonocasa", style: { display: "none" } },
                            React.createElement("label", { className: "control-label", htmlFor: "fononumbercasal" },
                                "N\u00FAmero\u00A0 ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.telecasaalum.numerotelefono, name: "fonocasa-alum-numerotelefono", id: "fononumbercasal", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput }),
                                React.createElement("span", { className: "input-group-text span-background", id: "number1icon" },
                                    React.createElement(AiIcons.AiOutlineNumber, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-2 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "cuentatw" }, "Cuenta Twitter"),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infopersonal.cuentatw, name: "infper-cuentatw", id: "cuentatw", "aria-describedby": "twittericon", maxLength: 99, onChange: this.handleChange }),
                                React.createElement("span", { className: "input-group-text span-background", id: "twittericon" },
                                    React.createElement(FaIcons.FaTwitter, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-2 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "cuentalid" }, "Cuenta LinkedIn"),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infopersonal.cuentalid, name: "infper-cuentalid", id: "cuentalid", "aria-describedby": "linkedinicon", maxLength: 99, onChange: this.handleChange }),
                                React.createElement("span", { className: "input-group-text span-background", id: "linkedinicon" },
                                    React.createElement(FaIcons.FaLinkedinIn, { style: { color: "white" } }))))),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-lg-2 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "cuentafb" }, "Cuenta Facebook"),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infopersonal.cuentafb, name: "infper-cuentafb", id: "cuentafb", "aria-describedby": "facebookicon", maxLength: 99, onChange: this.handleChange }),
                                React.createElement("span", { className: "input-group-text span-background", id: "facebookicon" },
                                    React.createElement(FaIcons.FaFacebookF, { style: { color: "white" } })))),
                        React.createElement("div", { className: "col-lg-4 col-sm-6 label-space" },
                            React.createElement("label", { className: "control-label", htmlFor: "emailalterno" },
                                "E-mail Personal ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                React.createElement("input", { className: "form-control form-control-sm", type: "email", value: this.state.infopersonal.emailalterno, name: "infper-emailalterno", id: "emailalterno", maxLength: 99, onChange: this.handleChange, required: true }),
                                React.createElement("span", { className: "input-group-text span-background", id: "mailalumnis" },
                                    React.createElement(AiIcons.AiOutlineMail, { style: { color: "white" } }))))),
                    React.createElement("br", null),
                    React.createElement("div", null,
                        React.createElement("label", { style: { fontSize: "large" } },
                            "(",
                            React.createElement("span", { className: "required-field" }, "*"),
                            ") Campos requeridos")))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { className: "form-group row", id: "siguiente-personal", style: { float: "right" } },
                React.createElement("button", { type: "submit", className: "btn btn-info buttonSpace" }, "Siguiente"))));
    };
    return InformacionPersonal;
}(React.Component));
exports.InformacionPersonal = InformacionPersonal;
//# sourceMappingURL=InformacionPersonal.js.map